import { secondsToMillis } from '@csp/csp-common-date-util';
import { executeFunctionInChunks } from '@csp/csp-common-util';
import fileDownload from 'js-file-download';
import { Download } from '../model/Download';

const DOWNLOADS_PER_SECOND = 10;

const download = ({ data, filename, format, mime }: Download): void => {
  const file = format ? `${filename}.${format}` : filename;
  fileDownload(data, file, mime);
};

/**
 * Browsers limit the number of downloads per second to 10,
 * this method pauses between each chunk of 10 to work around that limit.
 */
const downloadMany = async (downloads: Download[], pauseIntervalMs: number = secondsToMillis(1)): Promise<void> => {
  const chunkCallback = (downloadChunk: Download[]): void[] => downloadChunk.map(chunk => download(chunk));

  executeFunctionInChunks(DOWNLOADS_PER_SECOND, downloads, chunkCallback, pauseIntervalMs);
};

export const DownloadFileService = {
  download,
  downloadMany,
};
